var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDcotorEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3879 2.69922H15.3879C15.6532 2.69922 15.9075 2.80458 16.095 2.99211C16.2826 3.17965 16.3879 3.434 16.3879 3.69922V6.44222C16.3879 10.3762 13.3879 13.6942 10.3879 13.6942C7.38794 13.6942 4.38794 10.3762 4.38794 6.44222V3.69922C4.38794 3.434 4.4933 3.17965 4.68083 2.99211C4.86837 2.80458 5.12272 2.69922 5.38794 2.69922H7.38794",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.403 14.332C5.38798 19.8323 12.388 23.4992 16.388 19.8323",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7742 18.6875C20.1549 18.6875 21.2742 17.5682 21.2742 16.1875C21.2742 14.8068 20.1549 13.6875 18.7742 13.6875C17.3935 13.6875 16.2742 14.8068 16.2742 16.1875C16.2742 17.5682 17.3935 18.6875 18.7742 18.6875Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38818 10.9258C9.34611 11.5059 11.4303 11.5059 13.3882 10.9258",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0242 16.1875C19.0242 16.1212 18.9978 16.0576 18.9509 16.0107C18.9041 15.9638 18.8405 15.9375 18.7742 15.9375",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5242 16.1875C18.5242 16.2538 18.5505 16.3174 18.5974 16.3643C18.6443 16.4112 18.7079 16.4375 18.7742 16.4375C18.8405 16.4375 18.9041 16.4112 18.9509 16.3643C18.9978 16.3174 19.0242 16.2538 19.0242 16.1875",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7742 15.9375C18.7079 15.9375 18.6443 15.9638 18.5974 16.0107C18.5505 16.0576 18.5242 16.1212 18.5242 16.1875",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcotorEnable);
export default __webpack_public_path__ + "static/media/DcotorEnable.d7bb30fcac61d1d7dd877666a718efd3.svg";
export { ForwardRef as ReactComponent };